// src/components/Navbar.js
import { NavLink } from "react-router-dom";

export default function Navbar({ onLogout }) {
  const links = [
    { to: "/analiticas", label: "Analíticas" },
    { to: "/clientes",    label: "Clientes"  },
    { to: "/consumo",     label: "Consumo"   },
    { to: "/costos",      label: "Costos"    },
    // … demás
  ];

  return (
    <nav className="bg-primary text-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
        <span className="text-xl font-semibold tracking-wide">THE THING</span>

        <ul className="hidden md:flex gap-8 text-sm">
          {links.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  isActive
                    ? "underline decoration-white font-semibold"
                    : "hover:opacity-80"
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-white/20 grid place-items-center text-xs">UD</div>
            <span className="hidden sm:block text-sm">Usuario Demo</span>
          </div>
          <button
            onClick={onLogout}
            className="text-sm bg-white/20 hover:bg-white/30 px-3 py-1 rounded transition"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </nav>
  );
}
